import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

export default class extends Controller {
  static targets = ['message', 'modal', 'title', 'submitButton'];

  open(event) {
    event.preventDefault();
    this.form = event.currentTarget.closest('form');
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = event.params.message || '本当に削除しますか？';
    }
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = event.params.title || '削除の確認';
    }
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.textContent = event.params.submitLabel || '削除する';
    }
    Modal.getOrCreateInstance(this.modalTarget).show();
  }

  submit() {
    this.form?.requestSubmit();
  }
}
